/* istanbul ignore file */
import { Typography as MaterialTypography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Theme } from '../../theme';

import { StyledParagraphProperties } from './Paragraph.types';

export const StyledParagraph = styled(
    MaterialTypography,
)<StyledParagraphProperties>`
    a {
        color: ${({ theme }: { theme: Theme }) => theme.palette.common.blue};
        text-decoration: underline;
    }

    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};

    ${({ level, theme }: StyledParagraphProperties & { theme: Theme }) => {
        if (level === 'body-lg') {
            return theme.typography.text_18_lh_26;
        }

        if (level === 'body-md') {
            return theme.typography.text_16_lh_22;
        }

        if (level === 'body-sm') {
            return theme.typography.bodySmall;
        }

        if (level === 'body-xs') {
            return theme.typography.text_10_lh_14;
        }

        return ``;
    }};
`;
